import { GraphSchema } from '@camelot/server';

export interface UserCalendarSubscription {
  id: string;
  userId: string;
  userEmail: string;
  lastSync: string;
  isSync: boolean;
}

export interface UserCalendarSubscriptionCreationPayload {
  userId: string;
  userEmail: string;
  isSync: boolean;
}

export interface UserCalendarSubscriptionModifierPayload {
  id: string;
  isSync: boolean;
  updatedFields: string[];
}

export const userCalendarSubscriptionProps = new GraphSchema<UserCalendarSubscription>([
  'id',
  'userId',
  'userEmail',
  'lastSync',
  'isSync',
]);
